<template>
  <Modal class="my-modal" v-model="visible" title="选择底图生成头图" :footer-hide="true" :mask-closable="false" width="80%">
    <div class="cover-wrap">
      <div class="img-box" :class="{ sel: img === selImg.url }" v-for="(img,index) in productCoverList" :key="index">
        <img :src="img" @click="sel(img)" />
      </div>
    </div>
  </Modal>
</template>

<script>
export default {
  mixins: [],
  components: {},
  props: [],
  data() {
    return {
      key: '',
      selImg: {},
      visible: false,
      productCoverList: []
    };
  },
  methods: {
    sel(img) {
      const data = {
        key: this.key,
        url: img
      };
      this.selImg = data;
      this.$emit('success', this.selImg);
      setTimeout(() => {
        this.visible = false;
      }, 200);
    },
    async open(key, coverUrl = '') {
      this.key = key;
      this.selImg = {
        url: coverUrl
      };
      const close = this.$notice.loading('加载中');
      await this.getProductCover();
      close();
      this.visible = true;
    },
    // 获取系统内置产品图
    getProductCover() {
      this.$http({
        url: '/buz/productArticle/list/image',
        type: 'GET',
        data: {
          pageNo: 1,
          pageSize: 999
        }
      }).then(res => {
        if (res.data) {
          this.productCoverList = res.data;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-modal-body {
  padding: 16px 0 16px 16px;
}

.cover-wrap {
  max-height: 70vh;
  display: flex;
  flex-wrap: wrap;
  overflow: scroll;

  .img-box {
    // 比图片多2*2px边宽
    flex: 0 0 379px;
    width: 379px;
    height: 185px;
    margin: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 375px;
      height: 181px;
    }
  }

  .sel {
    border: 2px solid #236dff;
  }
}
</style>
